<template>
  <div v-if="visibleButtons.length > 0">
    <div v-if="visibleButtons.length > props.maxLength" class="btn-box">
      <template v-for="(el, i) in showBtn" :key="i">
        <BaseButton
          :type="el.type || 'primary'"
          :link="el.isLink"
          :disabled="el.disabled"
          @click="handleItemClick(el, props.operateItem)"
        >
          <Icon v-if="el.icon" :icon="el.icon" :color="el.iconColor || '#409eff'" />
          {{ getButtonLabel(el, props.operateItem) }}
        </BaseButton>
      </template>
      <ElDropdown @command="handleCommand">
        <Icon icon="weui:more-filled" color="#409eff" />
        <template #dropdown>
          <ElDropdownMenu class="table-opetation-more-dropdown">
            <ElDropdownItem
              v-for="(item, index) in dropData"
              :key="index"
              :command="beforeHandleCommand(item, props.operateItem)"
              class="link-text"
            >
              <Icon v-if="item.icon" :icon="item.icon" :color="item.iconColor || '#409eff'" />
              {{ getButtonLabel(item, props.operateItem) }}
            </ElDropdownItem>
          </ElDropdownMenu>
        </template>
      </ElDropdown>
    </div>
    <div v-else style="display: flex">
      <div v-for="(item, index) in visibleButtons" :key="index" class="btn-box">
        <BaseButton
          :type="item.type || 'primary'"
          :link="item.isLink"
          :disabled="item.disabled"
          @click="handleItemClick(item, props.operateItem)"
        >
          <Icon v-if="item.icon" :icon="item.icon" :color="item.iconColor || '#409eff'" />
          {{ getButtonLabel(item, props.operateItem) }}
        </BaseButton>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue'
import { ElTooltip, ElButton, ElDropdown, ElDropdownMenu, ElDropdownItem } from 'element-plus'
import { Icon } from '@/components/Icon'
const props = defineProps({
  /**
   * label: 按钮名称
   * icon: 图标名称
   * type: 按钮类型
   * isLink: 是否是链接按钮（文字按钮）
   * code: 按钮code，用于权限控制
   * onnClick: 自定义按钮点击事件
   * show: 按钮是否显示，支持布尔值、函数
   * permi: 按钮权限（优先级高于show），支持布尔值、函数
   */
  btnData: {
    type: Array,
    default: () => {
      return []
    }
  },
  operateItem: {
    type: Object,
    default: () => {}
  },
  maxLength: {
    type: Number,
    default: () => 4
  }
})

// 处理按钮点击事件
const handleItemClick = (item, data) => {
  if (item.onClick && typeof item.onClick === 'function') {
    item.onClick(data)
  } else {
    emit('routeEvent', data, item.code || item.label)
  }
}

const beforeHandleCommand = (item, data) => {
  return {
    item: item,
    data: data
  }
}

// 计算按钮标签文本
const getButtonLabel = (item, data) => {
  if (typeof item.label === 'function') {
    return item.label(data)
  }
  return item.label
}

// 下拉菜单点击事件
const handleCommand = (command) => {
  handleItemClick(command.item, command.data)
}

// 判断按钮是否应该显示
const isButtonVisible = (button, data) => {
  // 首先检查按钮自身的 permi 属性（优先级最高）
  if (button.permi !== undefined) {
    if (typeof button.permi === 'boolean') {
      if (!button.permi) {
        return false // 如果 permi 为 false，直接隐藏，不继续判断 show
      }
    } else if (typeof button.permi === 'function') {
      if (!button.permi(data)) {
        return false // 如果 permi 函数返回 false，直接隐藏，不继续判断 show
      }
    }
  }

  // 如果 permi 为 true 或未定义，继续判断 show 属性
  if (button.show === undefined) {
    return true
  }
  if (typeof button.show === 'boolean') {
    return button.show
  }
  if (typeof button.show === 'function') {
    return button.show(data)
  }
  return true
}

// 过滤显示的按钮
const visibleButtons = computed(() => {
  return props.btnData.filter((btn) => isButtonVisible(btn, props.operateItem))
})

// 计算显示的按钮（替代原来的 showBtn）
const showBtn = computed(() => {
  const visibleBtns = visibleButtons.value
  return visibleBtns.length > props.maxLength ? visibleBtns.slice(0, props.maxLength) : visibleBtns
})

// 计算下拉菜单中的按钮（替代原来的 dropData）
const dropData = computed(() => {
  const visibleBtns = visibleButtons.value
  return visibleBtns.length > props.maxLength ? visibleBtns.slice(props.maxLength) : []
})
</script>

<style lang="less" scoped>
.link-text .el-button {
  width: 100%;
  text-align: left;
}

.btn-box {
  .el-button {
    min-width: 0;
    margin-right: 12px;
  }
}

.el-dropdown-link {
  vertical-align: text-top;
}

.el-dropdown {
  vertical-align: middle;
}
</style>
